/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import { formatDistanceToNow } from 'date-fns';
import CodeModal from './CodeModal';
import { useUIStore } from '../../stores/uiStore';
import styles from './MessageItem.module.css';
import CodeRender from './CodeRender';

interface Reference {
  ref_num: number;
  id: string;
  title: string;
  url: string;
  chunk_index: number;
}

interface MessageItemProps {
  id: string;
  parts: Array<any>;
  role: 'user' | 'assistant';
  created_at: string;
  references?: Reference[];
}

const schemaWithHighlight = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    code: [
      ...(defaultSchema.attributes?.code || []),
      ['className'],
    ],
    span: [
      ...(defaultSchema.attributes?.span || []),
      ['className'],
    ],
  },
};

const MessageItem: React.FC<MessageItemProps> = ({
  parts,
  role,
  created_at,
  references,
}) => {
  const { openModalCode, setOpenModalCode } = useUIStore();
  const [showReferences, setShowReferences] = React.useState(false);
  console.log(parts)
//   function extractXMLSections(content: string): {
//   thinkCompleted?: string[];
//   thinkOpen?: boolean;
//   thinkPartial?: string;
//   answer?: string;
//   answerPartial?: string;
//   refs?: Record<number, { title: string; url: string | null }>;
//   useToolCompleted?: string[];
//   useToolOpen?: boolean;
//   useToolPartial?: string;
//   done: boolean;
// } {
//   // THINK
//   const thinkCompleted: string[] = [];
//   let thinkOpen = false;
//   let thinkPartial: string | undefined = undefined;

//   const thinkMatches = [...content.matchAll(/<think>([\s\S]*?)<\/think>/g)];
//   thinkCompleted.push(...thinkMatches.map(m => m[1].trim()));

//   const lastThinkStart = content.lastIndexOf('<think>');
//   const lastThinkEnd = content.lastIndexOf('</think>');
//   if (lastThinkStart > lastThinkEnd) {
//     const partial = content.substring(lastThinkStart + 7);
//     thinkPartial = partial.trim();
//   }

//   if (content.includes('<think>') && !content.includes('</think>')) {
//     thinkOpen = true;
//   }

//   // USETOLL
//   const useToolCompleted: string[] = [];
//   let useToolOpen = false;
//   let useToolPartial: string | undefined = undefined;

//   const useToolMatches = [...content.matchAll(/<usetool>([\s\S]*?)<\/usetool>/g)];
//   useToolCompleted.push(...useToolMatches.map(m => m[1].trim()));

//   const lastToolStart = content.lastIndexOf('<usetool>');
//   const lastToolEnd = content.lastIndexOf('</usetool>');
//   if (lastToolStart > lastToolEnd) {
//     const partial = content.substring(lastToolStart + 9);
//     useToolPartial = partial.trim();
//   }

//   if (content.includes('<usetool>') && !content.includes('</usetool>')) {
//     useToolOpen = true;
//   }

//   // ANSWER
//   let answer: string | undefined = undefined;
//   let answerPartial: string | undefined = undefined;
//   const answerMatch = content.match(/<answer>([\s\S]*?)<\/answer>/);
//   if (answerMatch) {
//     answer = answerMatch[1].replace(/<think>[\s\S]*?<\/think>/gi, '').trim();
//   } else {
//     const answerStart = content.indexOf('<answer>');
//     const answerEnd = content.indexOf('</answer>');
//     if (answerStart !== -1 && (answerEnd === -1 || answerEnd < answerStart)) {
//       answerPartial = content.substring(answerStart + 8).trim();
//     }
//   }

//   // REFS
//   const refs: Record<number, { title: string; url: string | null }> = {};
//   const refsMatch = content.match(/<refs>([\s\S]*?)<\/refs>/);
//   if (refsMatch) {
//     const refEntries = [...refsMatch[1].matchAll(/<(\d+)>(.*?)<\/\1>/g)];
//     for (const [_, key, value] of refEntries) {
//       const parts = value.split('|');
//       let rawUrl = parts.pop()?.trim() || null;

//       if (rawUrl?.startsWith('"') && rawUrl.endsWith('"')) rawUrl = rawUrl.slice(1, -1);
//       if (rawUrl?.startsWith("'") && rawUrl.endsWith("'")) rawUrl = rawUrl.slice(1, -1);

//       const title = parts.join('|').trim();
//       refs[parseInt(key)] = { title, url: rawUrl };
//     }
//   }

//   return {
//     thinkCompleted: thinkCompleted.length ? thinkCompleted : undefined,
//     thinkOpen,
//     thinkPartial,
//     answer,
//     answerPartial,
//     refs,
//     useToolCompleted: useToolCompleted.length ? useToolCompleted : undefined,
//     useToolOpen,
//     useToolPartial,
//     done: Boolean(answer),
//   };
// }


  function formatFootnotes(
    answer: string,
    refs?: Record<number, { title: string; url: string | null }>
  ) {
    return answer.replace(/\[\^(\d+)\]/g, (_, refNumStr) => {
      const refNum = parseInt(refNumStr, 10);
      const ref = refs?.[refNum];
      if (!ref) return ''; // fallback dacă lipsesc
      return `[[${refNum}]](#ref-${refNum})`; // sau `<sup>[${refNum}]</sup>`
    });
  }



  // const parsed = extractXMLSections(content);
  // const formattedAnswer = parsed.answer
  // ? formatFootnotes(parsed.answer, parsed.refs)
  // : '';

  // console.log('Parsed: ', parsed);

  // const referencesToRender: Reference[] = parsed.refs
  // ? Object.entries(parsed.refs).map(([numStr, val]) => ({
  //     ref_num: parseInt(numStr),
  //     id: `ref-${numStr}`,
  //     title: val.title,
  //     url: val.url || '',
  //     chunk_index: 0,
  //   }))
  // : references || [];


  const formatDate = (dateString: string) => {
    try {
      return formatDistanceToNow(new Date(dateString), { addSuffix: true });
    } catch (error) {
      return 'Invalid date';
    }
  };

  const getInitial = () => {
    return role === 'user' ? 'U' : 'Z';
  };

  let hasShownToolCall = false;
  console.log(parts)
  return (
    <div className={`${styles.messageContainer} ${role === 'user' ? styles.userMessages : styles.zvenMessages}`}>
      {role === 'user' ?
        <div className={styles.messageHeader}>
          <div
            className={`${styles.avatar} ${
              role === 'user' ? styles.userAvatar : styles.assistantAvatar
            }`}
          >
            {role === 'user' ? getInitial() : <img className={styles.avatar_icon} src="/assets/imgs/logo_zven_small.png" alt="Logo" />}
          </div>
          <div className={styles.sender}>
            {role === 'user' ? 'You' : ''}
          </div>
          <div className={styles.timestamp}>{role === 'user' ? formatDate(created_at) : ""}</div>
        </div>
      :
      <></>
      }


      <div className={styles.messageContent}>
        {role === 'assistant' && (
          <div className={styles.messageHeader}>
            <div
              className={`${styles.avatar} ${styles.assistantAvatar}`}
            >
              <img className={styles.avatar_icon} src="/assets/imgs/logo_zven_small.png" alt="Logo" />
            </div>
          </div>
        )}
        <div className={styles.messageWrapper}>
          {parts.map((part, index) => {
            if (part.part_type === 'tool_call_actual') {
              if (hasShownToolCall) return null;
              hasShownToolCall = true;
              return (
                <div key={index} className={styles.toolUsage}>
                  <em>Ok, need to consult my documentation, please hang on...</em>
                </div>
              );
            }

            if (part.part_type === 'think') {
              return (
                <div key={index} className={styles.think}>
                  <em>{part.content}</em>
                </div>
              );
            }

            if (part.part_type === 'raw_text' || part.part_type === 'answer') {
              return (
                <div key={index} className="markdown">
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[
                      rehypeHighlight,
                      [rehypeSanitize, schemaWithHighlight],
                    ]}
                    components={{
                      code: CodeRender,
                      a: ({ href, children, ...props }) => {
                        if (href?.startsWith('#ref-')) {
                          return (
                            <a
                              href={href}
                              className={styles.footnoteRef}
                              onClick={(e) => {
                                e.preventDefault();
                                setShowReferences(prev => !prev);
                                const targetId = href.replace('#', '');
                                const el = document.getElementById(targetId);
                                if (el) el.scrollIntoView({ behavior: 'smooth' });
                              }}
                              {...props}
                            >
                              {children}
                            </a>
                          );
                        }

                        return <a href={href} {...props}>{children}</a>;
                      },
                    }}
                  >
                    {part.content}
                  </ReactMarkdown>
                </div>
              );
            }

            return null;
          })}
          {/* USETOOL - doar dacă există și e assistant */}

        </div>
      </div>



      {openModalCode && (
        <CodeModal code={openModalCode} onClose={() => setOpenModalCode(null)} />
      )}
    </div>
  );
};

export default MessageItem;